import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'
import { dataToFormData } from '@/utils/helpers'

const actions = {
  getCollection({ commit }, payload) {
    API.sales.getCollection(payload)
      .then(({ data: { data: { results }, include, meta } }) => {
        if (meta.page === 1) {
          commit('setCollection', results)
          commit('setFiltersCollection', include.filters)
          commit('setIsControls', true)
        } else {
          commit('updateCollection', results)
        }

        commit('setPagination', meta)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось получить список предложений.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('setIsLoading', false)
        commit('setIsLoadingMore', false)
      })
  },
  getSale({ commit }, id) {
    API.sales.get(id)
      .then(({ data: { data } }) => {
        commit('setEditForm', data)

        let visibilitySettings

        if (data.searchDate && data.extraDays) {
          visibilitySettings = 'dateWithShift'
        } else if (data.searchDate) {
          visibilitySettings = 'dateOnly'
        } else {
          visibilitySettings = 'shiftOnly'
        }

        commit('setVisibilitySettingsType', visibilitySettings)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось получить детали предложения.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsModalFormLoading', false)
      })
  },
  updateSale({ commit, dispatch, state }, { id, data }) {
    commit('updateIsModalFormLoading', true)

    API.sales.update({ id, data })
      .then(() => {
        commit('setModalFormMessage', 'Горячее предложение обновлено')

        dispatch('getCollection', {
          ...state.form,
          ...state.filters,
          page: 1,
          perPage: 10
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Предложение не было обновлено.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsModalFormLoading', false)
      })
  },
  uploadImage({ commit }, image) {
    commit('setIsImageUploading', true)

    const payload = dataToFormData({ image })

    API.sales.uploadImage(payload)
      .then(({ data: { data: { id } } }) => {
        commit('setField', {
          target: 'editForm.imageSrc',
          value: window.URL.createObjectURL(image)
        })
        commit('setField', {
          target: 'editForm.imageId',
          value: id
        })

        window.URL.revokeObjectURL(image)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Предложение не было обновлено.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('setIsImageUploading', false)
      })
  },
  createSale({ commit, dispatch, state }, payload) {
    commit('updateIsModalFormLoading', true)

    API.sales.add(payload)
      .then(() => {
        commit('setModalFormMessage', 'Горячее предложение добавлено')

        dispatch('getCollection', {
          ...state.form,
          ...state.filters,
          page: 1,
          perPage: 10
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Предложение не было создано.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsModalFormLoading', false)
      })
  },
  removeSale({ commit, dispatch, state }, id) {
    API.sales.remove(id)
      .then(() => {
        commit('setModalFormMessage', 'Горячее предложение удалено')

        dispatch('getCollection', {
          ...state.form,
          ...state.filters,
          page: 1,
          perPage: 10
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Предложение не было удалено.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateIsModalFormLoading', false)
      })
  }
}

export default actions